// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"955":"8e5de4ad","982":"24eec9c0"}[chunkId] + ".chunk.css";
};